const measurementList = [
    {
        code: 'шт',
        name: 'шт',
    },
    {
        code: 'кг',
        name: 'кг',
    },
];

export const schemaList = [
    {
        documentCode: 'DSG',
        name: 'Сменно-суточное задание',
        settings: {
            statusList: [
                {
                    code: 'work',
                    name: 'В работе',
                    styleCode: 'yellow',
                },
                {
                    code: 'completed',
                    name: 'Завершен',
                    styleCode: 'green',
                },
            ],
        },
    },
    {
        documentCode: 'WO',
        name: 'Заказ на склад',
        settings: {
            statusList: [
                {
                    code: 'work',
                    name: 'В работе',
                    styleCode: 'yellow',
                },
                {
                    code: 'completed',
                    name: 'Завершен',
                    styleCode: 'green',
                },
            ],
        },
    },
    {
        documentCode: 'MES',
        name: 'MES заказ',
        settings: {
            statusList: [
                {
                    code: 'work',
                    name: 'В работе',
                    styleCode: 'yellow',
                },
                {
                    code: 'completed',
                    name: 'Завершен',
                    styleCode: 'green',
                },
            ],
        },
    },
    {
        documentCode: 'QC',
        name: 'Контроль качества',
        settings: {
            sla: [
                {
                    code: 'latencyPeriod',
                    name: 'Время до взятия заявки в работу',
                    calcFn: 'secondDiff',
                    unitType: 'min',
                    normative: 15,
                    baseObject: 'firstStatusHistory',
                    baseStatus: 'new',
                    updateMode: 'keepFirstValue',
                    triggerStatuses: [
                        'work',
                    ],
                },
                {
                    code: 'responseTime',
                    name: 'Время на решение заявки',
                    calcFn: 'secondDiff',
                    unitType: 'min',
                    normative: 240,
                    baseObject: 'lastStatusHistory',
                    baseStatus: 'work',
                    updateMode: 'sumValue',
                    triggerStatuses: [
                        'completed',
                    ],
                },
                {
                    code: 'totalTime',
                    name: 'Общее время до завершения заявки',
                    calcFn: 'secondDiff',
                    unitType: 'hour',
                    normative: 8,
                    baseObject: 'firstStatusHistory',
                    baseStatus: 'new',
                    updateMode: 'replaceLastValue',
                    triggerStatuses: [
                        'all',
                    ],
                },
                {
                    code: 'reopenCount',
                    name: 'Количество возвратов',
                    calcFn: 'intVal',
                    unitType: 'times',
                    normative: 0,
                    baseObject: 'statusCounter',
                    baseStatus: 'new',
                    updateMode: 'replaceLastValue',
                    triggerStatuses: [
                        'new',
                    ],
                },
            ],
            plugins: [
                'attachments',
                'comments',
                'timeTracking',
                'qcResult',
            ],
            typeList: [
                {
                    code: 'scheduled',
                    icon: {
                        name: 'CalendarMonth',
                        color: '#5472d3',
                    },
                    name: 'Плановый контроль',
                },
                {
                    code: 'unscheduled',
                    icon: {
                        name: 'EventBusy',
                        color: '#6d4c41',
                    },
                    name: 'Внеплановый контроль',
                },
            ],
            workflow: [
                {
                    toStatus: 'work',
                    fromStatus: 'new',
                    toolbarAction: {
                        button: 'В работу',
                        formProps: {
                            title: 'В работу',
                            addons: [
                                'comment',
                            ],
                            button: 'В работу',
                            fields: [
                                'assignee',
                            ],
                        },
                    },
                },
                {
                    toStatus: 'completed',
                    fromStatus: 'work',
                    toolbarAction: {
                        button: 'Завершить задачу',
                        formProps: {
                            title: 'Завершить задачу',
                            addons: [
                                'comment',
                            ],
                            button: 'Завершить',
                            fields: [],
                        },
                    },
                },
                {
                    toStatus: 'new',
                    fromStatus: 'completed',
                    toolbarAction: {
                        button: 'Переоткрыть',
                        formProps: {
                            title: 'Переотрытие задания',
                            addons: [
                                'comment',
                            ],
                            button: 'Переоткрыть',
                            fields: [
                                'assignee',
                            ],
                        },
                    },
                },
            ],
            editFields: [
                'type',
                {
                    type: 'hr',
                },
                'title',
                'description',
                'priority',
                'assignee',
                'department',
                'departmentIds',
                'operation',
                {
                    type: 'row',
                    title: 'Количество',
                    rowProps: {
                        fields: [
                            {
                                fieldName: 'amount',
                                fullWidth: false,
                                inputProps: {
                                    min: 0,
                                },
                            },
                            {
                                selectSx: {
                                    width: '150px',
                                },
                                defaultValue: 'шт',
                                fieldName: 'measurement',
                            },
                        ],
                    },
                },
                'equipmentModel',
                'inventoryNumber',
                'vendorCode',
                'routeCode',
                'componentName',
            ],
            statusList: [
                {
                    code: 'new',
                    name: 'Новая',
                    styleCode: 'blue',
                },
                {
                    code: 'work',
                    name: 'В работе',
                    styleCode: 'yellow',
                },
                {
                    code: 'completed',
                    name: 'Завершенная',
                    styleCode: 'green',
                },
            ],
            cloneFields: [
                'title',
            ],
            gridColumns: [
                {
                    width: 30,
                    headerName: '',
                    sourceProperty: 'priority',
                },
                {
                    headerName: '',
                    sourceProperty: 'type',
                },
                {
                    width: 150,
                    headerName: 'Ключ',
                    componentName: 'TwoLineCell',
                    sourcePropertyMap: {
                        primaryValue: 'issueKey',
                        secondaryValue: 'statusCode',
                    },
                },
                'title',
                {
                    width: 200,
                    headerName: 'Автор/Обновлено',
                    componentName: 'TwoLineCell',
                    sourcePropertyMap: {
                        primaryValue: 'author',
                        secondaryValue: 'changedAtUtc',
                    },
                },
            ],
            createFields: [
                'type',
                {
                    type: 'hr',
                },
                'title',
                'description',
                'priority',
                'assignee',
                'department',
                'departmentIds',
                'operation',
                {
                    type: 'row',
                    title: 'Количество',
                    rowProps: {
                        fields: [
                            {
                                fieldName: 'amount',
                                fullWidth: false,
                                inputProps: {
                                    min: 0,
                                },
                            },
                            {
                                selectSx: {
                                    width: '150px',
                                },
                                defaultValue: 'шт',
                                fieldName: 'measurement',
                            },
                        ],
                    },
                },
            ],
            dataProperties: {
                type: {
                    name: 'Тип',
                    type: 'identifier',
                    sizeVariant: 'medium',
                    editProps: {
                        allowEditOnDetailsPage: true,
                    },
                    typeProps: {
                        initValue: 'scheduled',
                        sourceListPropertyKey: 'typeList',
                    },
                    columnProps: {
                        align: 'center',
                        width: 30,
                    },
                    sourceObject: 'data',
                },
                title: {
                    name: 'Название',
                    type: 'string',
                    sizeVariant: 'long',
                    isRequired: true,
                    columnProps: {
                        flex: 1,
                        width: 100,
                        minWidth: 100,
                    },
                },
                amount: {
                    name: 'Количество',
                    type: 'number',
                    sizeVariant: 'short',
                    sourceObject: 'data',
                },
                author: {
                    name: 'Автор',
                    type: 'user',
                    sizeVariant: 'medium',
                    columnProps: {
                        width: 100,
                    },
                    isDerivative: true,
                    derivativeProps: {
                        sourcePropertyPath: 'createdBy',
                    },
                },
                assignee: {
                    name: 'Исполнитель',
                    type: 'user',
                    sizeVariant: 'medium',
                    columnProps: {
                        width: 100,
                    },
                    isDerivative: true,
                    derivativeProps: {
                        sourcePropertyPath: 'assigneeId',
                    },
                },
                issueKey: {
                    name: 'Ключ',
                    sizeVariant: 'short',
                    type: 'documentKey',
                    columnProps: {
                        width: 90,
                    },
                },
                priority: {
                    name: 'Приоритет',
                    type: 'priority',
                    sizeVariant: 'medium',
                    editProps: {
                        allowEditOnDetailsPage: true,
                    },
                    typeProps: {
                        initValue: '2',
                    },
                    columnProps: {
                        align: 'center',
                        width: 85,
                    },
                },
                operation: {
                    name: 'Операция',
                    type: 'string',
                    sizeVariant: 'medium',
                    typeProps: {
                        defaultValue: 'Не задана',
                    },
                    sourceObject: 'data',
                },
                routeCode: {
                    name: 'ВИМ',
                    type: 'string',
                    sizeVariant: 'short',
                    typeProps: {
                        defaultValue: 'Не указана',
                    },
                    sourceObject: 'data',
                },
                department: {
                    name: 'Цех.Участок',
                    type: 'entity',
                    sizeVariant: 'short',
                    typeProps: {
                        entityType: 'department',
                    },
                    sourceObject: 'data',
                },
                statusCode: {
                    name: 'Статус',
                    type: 'status',
                    sizeVariant: 'medium',
                    columnProps: {
                        width: 95,
                    },
                },
                vendorCode: {
                    name: 'Артикул',
                    type: 'string',
                    sizeVariant: 'medium',
                    typeProps: {
                        defaultValue: 'Не указана',
                    },
                    sourceObject: 'data',
                },
                description: {
                    name: 'Описание',
                    sizeVariant: 'full',
                    type: 'text',
                },
                measurement: {
                    name: 'Единица измерения',
                    type: 'identifier',
                    sizeVariant: 'short',
                    typeProps: {
                        sourceListPropertyKey: 'measurementList',
                    },
                    sourceObject: 'data',
                },
                changedAtUtc: {
                    name: 'Обновлено',
                    type: 'utcDate',
                    typeProps: {
                        displayFormat: 'dd.MM.yyyy HH:mm',
                    },
                    columnProps: {
                        width: 135,
                    },
                },
                createdAtUtc: {
                    name: 'Дата создания',
                    type: 'utcDate',
                    typeProps: {
                        displayFormat: 'dd.MM.yyyy HH:mm',
                    },
                    columnProps: {
                        width: 135,
                    },
                },
                componentName: {
                    name: 'Название материала',
                    type: 'string',
                    sizeVariant: 'long',
                    typeProps: {
                        defaultValue: 'Не указана',
                    },
                    sourceObject: 'data',
                },
                departmentIds: {
                    name: 'Список участков',
                    type: 'array',
                    editProps: {
                        isHidden: true,
                    },
                    typeProps: {
                        entityType: 'number',
                    },
                },
                equipmentModel: {
                    name: 'Рабочее место',
                    type: 'string',
                    sizeVariant: 'long',
                    typeProps: {
                        defaultValue: 'Не указана',
                    },
                    sourceObject: 'data',
                },
                inventoryNumber: {
                    name: 'Инвентарный номер',
                    type: 'string',
                    sizeVariant: 'medium',
                    typeProps: {
                        defaultValue: 'Не указан',
                    },
                    sourceObject: 'data',
                },
            },
            dateInfoFields: [
                'createdAtUtc',
                'changedAtUtc',
            ],
            mainInfoFields: [
                'type',
                'statusCode',
                'priority',
                'equipmentModel',
                {
                    title: 'Цех',
                    fieldName: 'department',
                    propertyName: 'manufacture',
                },
                'inventoryNumber',
                {
                    title: 'Участок',
                    fieldName: 'department',
                    propertyName: 'sector',
                },
                'operation',
                {
                    title: 'Количество',
                    fieldName: 'amount',
                    viewFormat: '{amount} {measurement}',
                },
                'vendorCode',
                'routeCode',
                'componentName',
            ],
            userInfoFields: [
                'assignee',
                'author',
            ],
            measurementList: measurementList,
        },
    },
    {
        documentCode: 'SALE',
        name: 'Сбытовой заказ',
        settings: {
            statusList: [
                {
                    code: 'work',
                    name: 'В работе',
                    styleCode: 'yellow',
                },
                {
                    code: 'completed',
                    name: 'Завершен',
                    styleCode: 'green',
                },
            ],
        },
    },
    {
        documentCode: 'TECH',
        name: 'Технология',
        settings: {
            sla: [
                {
                    code: 'latencyPeriod',
                    name: 'Время до взятия заявки в работу',
                    calcFn: 'secondDiff',
                    unitType: 'min',
                    normative: 15,
                    baseObject: 'firstStatusHistory',
                    baseStatus: 'new',
                    updateMode: 'keepFirstValue',
                    triggerStatuses: [
                        'work',
                    ],
                },
                {
                    code: 'responseTime',
                    name: 'Время на решение заявки',
                    calcFn: 'secondDiff',
                    unitType: 'min',
                    normative: 240,
                    baseObject: 'lastStatusHistory',
                    baseStatus: 'work',
                    updateMode: 'sumValue',
                    triggerStatuses: [
                        'completed',
                    ],
                },
                {
                    code: 'totalTime',
                    name: 'Общее время до завершения заявки',
                    calcFn: 'secondDiff',
                    unitType: 'hour',
                    normative: 8,
                    baseObject: 'firstStatusHistory',
                    baseStatus: 'new',
                    updateMode: 'replaceLastValue',
                    triggerStatuses: [
                        'all',
                    ],
                },
                {
                    code: 'reopenCount',
                    name: 'Количество возвратов',
                    calcFn: 'intVal',
                    unitType: 'times',
                    normative: 0,
                    baseObject: 'statusCounter',
                    baseStatus: 'new',
                    updateMode: 'replaceLastValue',
                    triggerStatuses: [
                        'new',
                    ],
                },
            ],
            plugins: [
                'attachments',
                'comments',
                'timeTracking',
            ],
            typeList: [
                {
                    code: 'change-tech',
                    icon: {
                        name: 'DriveFileRenameOutlineOutlined',
                        color: '#5472d3',
                    },
                    name: 'Изменение технологии',
                },
                {
                    code: 'change-sla',
                    icon: {
                        name: 'HistoryOutlined',
                        color: '#5472d3',
                    },
                    name: 'Уточнение норм выполнения операции',
                },
                {
                    code: 'new-route',
                    icon: {
                        name: 'AddBoxOutlined',
                        color: '#5472d3',
                    },
                    name: 'Новый ВИМ',
                },
                {
                    code: 'new-mes-order',
                    icon: {
                        name: 'AddBoxOutlined',
                        color: '#5472d3',
                    },
                    name: 'Новый MES-заказ',
                },
            ],
            workflow: [
                {
                    toStatus: 'work',
                    fromStatus: 'new',
                    toolbarAction: {
                        button: 'В работу',
                        formProps: {
                            title: 'В работу',
                            addons: [
                                'comment',
                            ],
                            button: 'В работу',
                            fields: [
                                'assignee',
                            ],
                        },
                    },
                },
                {
                    toStatus: 'completed',
                    fromStatus: 'work',
                    toolbarAction: {
                        button: 'Завершить задачу',
                        formProps: {
                            title: 'Завершить задачу',
                            addons: [
                                'comment',
                            ],
                            button: 'Завершить',
                            fields: [],
                        },
                    },
                },
                {
                    toStatus: 'new',
                    fromStatus: 'completed',
                    toolbarAction: {
                        button: 'Переоткрыть',
                        formProps: {
                            title: 'Переотрытие задания',
                            addons: [
                                'comment',
                            ],
                            button: 'Переоткрыть',
                            fields: [
                                'assignee',
                            ],
                        },
                    },
                },
            ],
            editFields: [
                'type',
                {
                    type: 'hr',
                },
                'title',
                'description',
                'priority',
                'assignee',
                'orderNumber',
                'routeCode',
                'vendorCode',
                'componentName',
            ],
            statusList: [
                {
                    code: 'new',
                    name: 'Новая',
                    styleCode: 'blue',
                },
                {
                    code: 'work',
                    name: 'В работе',
                    styleCode: 'yellow',
                },
                {
                    code: 'completed',
                    name: 'Завершенная',
                    styleCode: 'green',
                },
            ],
            cloneFields: [
                'title',
            ],
            gridColumns: [
                {
                    width: 30,
                    headerName: '',
                    sourceProperty: 'priority',
                },
                {
                    headerName: '',
                    sourceProperty: 'type',
                },
                {
                    width: 150,
                    headerName: 'Ключ',
                    componentName: 'TwoLineCell',
                    sourcePropertyMap: {
                        primaryValue: 'issueKey',
                        secondaryValue: 'statusCode',
                    },
                },
                'title',
                {
                    width: 200,
                    headerName: 'Автор/Обновлено',
                    componentName: 'TwoLineCell',
                    sourcePropertyMap: {
                        primaryValue: 'author',
                        secondaryValue: 'changedAtUtc',
                    },
                },
            ],
            createFields: [
                'type',
                {
                    type: 'hr',
                },
                'title',
                'description',
                'orderNumber',
                'routeCode',
                'vendorCode',
                'componentName',
            ],
            dataProperties: {
                type: {
                    name: 'Тип',
                    type: 'identifier',
                    sizeVariant: 'medium',
                    editProps: {
                        allowEditOnDetailsPage: true,
                    },
                    typeProps: {
                        initValue: 'scheduled',
                        sourceListPropertyKey: 'typeList',
                    },
                    columnProps: {
                        align: 'center',
                        width: 30,
                    },
                    sourceObject: 'data',
                },
                title: {
                    name: 'Название',
                    type: 'string',
                    sizeVariant: 'long',
                    isRequired: true,
                    columnProps: {
                        flex: 1,
                        width: 100,
                        minWidth: 100,
                    },
                },
                author: {
                    name: 'Автор',
                    type: 'user',
                    sizeVariant: 'medium',
                    columnProps: {
                        width: 100,
                    },
                    isDerivative: true,
                    derivativeProps: {
                        sourcePropertyPath: 'createdBy',
                    },
                },
                assignee: {
                    name: 'Исполнитель',
                    type: 'user',
                    sizeVariant: 'medium',
                    columnProps: {
                        width: 100,
                    },
                    isDerivative: true,
                    derivativeProps: {
                        sourcePropertyPath: 'assigneeId',
                    },
                },
                issueKey: {
                    name: 'Ключ',
                    type: 'documentKey',
                    sizeVariant: 'short',
                    columnProps: {
                        width: 90,
                    },
                },
                priority: {
                    name: 'Приоритет',
                    type: 'priority',
                    sizeVariant: 'medium',
                    editProps: {
                        allowEditOnDetailsPage: true,
                    },
                    typeProps: {
                        initValue: '2',
                    },
                    columnProps: {
                        align: 'center',
                        width: 85,
                    },
                },
                routeCode: {
                    name: 'ВИМ',
                    type: 'string',
                    sizeVariant: 'short',
                    typeProps: {
                        defaultValue: 'Не указана',
                    },
                    sourceObject: 'data',
                },
                department: {
                    name: 'Цех.Участок',
                    type: 'entity',
                    sizeVariant: 'short',
                    typeProps: {
                        entityType: 'department',
                    },
                    sourceObject: 'data',
                },
                statusCode: {
                    name: 'Статус',
                    type: 'status',
                    sizeVariant: 'medium',
                    columnProps: {
                        width: 95,
                    },
                },
                vendorCode: {
                    name: 'Артикул',
                    type: 'string',
                    sizeVariant: 'medium',
                    typeProps: {
                        defaultValue: 'Не указана',
                    },
                    sourceObject: 'data',
                },
                description: {
                    name: 'Описание',
                    type: 'text',
                    sizeVariant: 'full',
                },
                orderNumber: {
                    name: 'Заказ',
                    type: 'string',
                    sizeVariant: 'medium',
                    typeProps: {
                        defaultValue: 'Не указан',
                    },
                    sourceObject: 'data',
                },
                changedAtUtc: {
                    name: 'Обновлено',
                    type: 'utcDate',
                    typeProps: {
                        displayFormat: 'dd.MM.yyyy HH:mm',
                    },
                    columnProps: {
                        width: 135,
                    },
                },
                createdAtUtc: {
                    name: 'Дата создания',
                    type: 'utcDate',
                    typeProps: {
                        displayFormat: 'dd.MM.yyyy HH:mm',
                    },
                    columnProps: {
                        width: 135,
                    },
                },
                componentName: {
                    name: 'Название материала',
                    type: 'string',
                    sizeVariant: 'long',
                    typeProps: {
                        defaultValue: 'Не указана',
                    },
                    sourceObject: 'data',
                },
                departmentIds: {
                    name: 'Список участков',
                    type: 'array',
                    editProps: {
                        isHidden: true,
                    },
                    typeProps: {
                        entityType: 'number',
                    },
                },
            },
            dateInfoFields: [
                'createdAtUtc',
                'changedAtUtc',
            ],
            mainInfoFields: [
                'type',
                'statusCode',
                'orderNumber',
                'routeCode',
                'vendorCode',
                'componentName',
            ],
            userInfoFields: [
                'assignee',
                'author',
            ],
        },
    },
    {
        documentCode: 'TOOL',
        name: 'Инструменты и СТО',
        settings: {
            sla: [
                {
                    code: 'latencyPeriod',
                    name: 'Время до взятия заявки в работу',
                    calcFn: 'secondDiff',
                    unitType: 'min',
                    normative: 15,
                    baseObject: 'firstStatusHistory',
                    baseStatus: 'new',
                    updateMode: 'keepFirstValue',
                    triggerStatuses: [
                        'work',
                    ],
                },
                {
                    code: 'responseTime',
                    name: 'Время на решение заявки',
                    calcFn: 'secondDiff',
                    unitType: 'min',
                    normative: 240,
                    baseObject: 'lastStatusHistory',
                    baseStatus: 'work',
                    updateMode: 'sumValue',
                    triggerStatuses: [
                        'completed',
                    ],
                },
                {
                    code: 'totalTime',
                    name: 'Общее время до завершения заявки',
                    calcFn: 'secondDiff',
                    unitType: 'hour',
                    normative: 8,
                    baseObject: 'firstStatusHistory',
                    baseStatus: 'new',
                    updateMode: 'replaceLastValue',
                    triggerStatuses: [
                        'all',
                    ],
                },
                {
                    code: 'reopenCount',
                    name: 'Количество возвратов',
                    calcFn: 'intVal',
                    unitType: 'times',
                    normative: 0,
                    baseObject: 'statusCounter',
                    baseStatus: 'new',
                    updateMode: 'replaceLastValue',
                    triggerStatuses: [
                        'new',
                    ],
                },
            ],
            plugins: [
                'attachments',
                'comments',
                'attachmentWithTemplate',
                'timeTracking',
            ],
            testData: [
                {
                    id: 1,
                    code: 'AC.GHI01552',
                    name: 'Державка MCLNR2525M12',
                    amount: '1 шт',
                    issueType: 'return-tool',
                    wearPercentage: 25,
                },
                {
                    id: 2,
                    code: 'AC.GHI02326',
                    name: 'Державка MVJNR2525M16',
                    amount: '1 шт',
                    issueType: 'return-tool',
                    wearPercentage: 15,
                },
                {
                    id: 3,
                    code: 'D35CXA-4M-25-DUAL',
                    name: 'Держатель Dorian для расточной оправки ф 25мм, разрезной для длинных вылетов',
                    amount: '1 шт',
                    issueType: 'return-tool',
                    wearPercentage: 30,
                },
                {
                    id: 4,
                    code: 'AC.GHI02403',
                    name: 'Оправка расточная S16Q-SCLCR09',
                    amount: '1 шт',
                    issueType: 'delivery',
                    wearPercentage: 0,
                },
                {
                    id: 5,
                    code: 'AC.GII11760',
                    name: 'Пластина токарная WNMG080408-TBPP-CC1025',
                    amount: '1 шт',
                    issueType: 'delivery',
                    wearPercentage: 10,
                },
            ],
            typeList: [
                {
                    code: 'delivery',
                    icon: {
                        name: 'Plumbing',
                        color: '#5472d3',
                    },
                    name: 'Выдача инструмента и СТО',
                },
                {
                    code: 'return-tool',
                    icon: {
                        name: 'KeyboardReturn',
                        color: '#6d4c41',
                    },
                    name: 'Возврат инструмента и СТО',
                },
            ],
            workflow: [
                {
                    toStatus: 'work',
                    fromStatus: 'new',
                    toolbarAction: {
                        button: 'В работу',
                        formProps: {
                            title: 'В работу',
                            addons: [
                                'comment',
                            ],
                            button: 'В работу',
                            fields: [
                                'assignee',
                            ],
                        },
                    },
                },
                {
                    toStatus: 'completed',
                    fromStatus: 'work',
                    toolbarAction: {
                        button: 'Завершить задачу',
                        formProps: {
                            title: 'Завершить задачу',
                            addons: [
                                'comment',
                            ],
                            button: 'Завершить',
                            fields: [],
                        },
                    },
                },
                {
                    toStatus: 'new',
                    fromStatus: 'completed',
                    toolbarAction: {
                        button: 'Переоткрыть',
                        formProps: {
                            title: 'Переотрытие задания',
                            addons: [
                                'comment',
                            ],
                            button: 'Переоткрыть',
                            fields: [
                                'assignee',
                            ],
                        },
                    },
                },
            ],
            editFields: [
                'type',
                {
                    type: 'hr',
                },
                'title',
                'description',
                'priority',
                'assignee',
                'department',
                'departmentIds',
                'equipmentModel',
                'inventoryNumber',
            ],
            statusList: [
                {
                    code: 'new',
                    name: 'Новая',
                    styleCode: 'blue',
                },
                {
                    code: 'work',
                    name: 'В работе',
                    styleCode: 'yellow',
                },
                {
                    code: 'completed',
                    name: 'Завершенная',
                    styleCode: 'green',
                },
            ],
            cloneFields: [
                'title',
            ],
            gridColumns: [
                {
                    width: 30,
                    headerName: '',
                    sourceProperty: 'priority',
                },
                {
                    headerName: '',
                    sourceProperty: 'type',
                },
                {
                    width: 150,
                    headerName: 'Ключ',
                    componentName: 'TwoLineCell',
                    sourcePropertyMap: {
                        primaryValue: 'issueKey',
                        secondaryValue: 'statusCode',
                    },
                },
                'title',
                {
                    width: 200,
                    headerName: 'Автор/Обновлено',
                    componentName: 'TwoLineCell',
                    sourcePropertyMap: {
                        primaryValue: 'author',
                        secondaryValue: 'changedAtUtc',
                    },
                },
            ],
            createFields: [
                'type',
                {
                    type: 'hr',
                },
                'title',
                'description',
                'priority',
                'assignee',
                'department',
                'departmentIds',
            ],
            dataProperties: {
                type: {
                    name: 'Тип',
                    type: 'identifier',
                    sizeVariant: 'medium',
                    editProps: {
                        allowEditOnDetailsPage: true,
                    },
                    typeProps: {
                        initValue: 'scheduled',
                        sourceListPropertyKey: 'typeList',
                    },
                    columnProps: {
                        align: 'center',
                        width: 30,
                    },
                    sourceObject: 'data',
                },
                title: {
                    name: 'Название',
                    type: 'string',
                    sizeVariant: 'long',
                    isRequired: true,
                    columnProps: {
                        flex: 1,
                        width: 100,
                        minWidth: 100,
                    },
                },
                author: {
                    name: 'Автор',
                    type: 'user',
                    sizeVariant: 'medium',
                    columnProps: {
                        width: 100,
                    },
                    isDerivative: true,
                    derivativeProps: {
                        sourcePropertyPath: 'createdBy',
                    },
                },
                assignee: {
                    name: 'Исполнитель',
                    type: 'user',
                    sizeVariant: 'medium',
                    columnProps: {
                        width: 100,
                    },
                    isDerivative: true,
                    derivativeProps: {
                        sourcePropertyPath: 'assigneeId',
                    },
                },
                issueKey: {
                    name: 'Ключ',
                    type: 'documentKey',
                    sizeVariant: 'short',
                    columnProps: {
                        width: 90,
                    },
                },
                priority: {
                    name: 'Приоритет',
                    type: 'priority',
                    sizeVariant: 'medium',
                    editProps: {
                        allowEditOnDetailsPage: true,
                    },
                    typeProps: {
                        initValue: '2',
                    },
                    columnProps: {
                        align: 'center',
                        width: 85,
                    },
                },
                department: {
                    name: 'Цех.Участок',
                    type: 'entity',
                    sizeVariant: 'short',
                    typeProps: {
                        entityType: 'department',
                    },
                    sourceObject: 'data',
                },
                statusCode: {
                    name: 'Статус',
                    type: 'status',
                    sizeVariant: 'medium',
                    columnProps: {
                        width: 95,
                    },
                },
                description: {
                    name: 'Описание',
                    type: 'text',
                    sizeVariant: 'full',
                },
                changedAtUtc: {
                    name: 'Обновлено',
                    type: 'utcDate',
                    typeProps: {
                        displayFormat: 'dd.MM.yyyy HH:mm',
                    },
                    columnProps: {
                        width: 135,
                    },
                },
                createdAtUtc: {
                    name: 'Дата создания',
                    type: 'utcDate',
                    typeProps: {
                        displayFormat: 'dd.MM.yyyy HH:mm',
                    },
                    columnProps: {
                        width: 135,
                    },
                },
                departmentIds: {
                    name: 'Список участков',
                    type: 'array',
                    editProps: {
                        isHidden: true,
                    },
                    typeProps: {
                        entityType: 'number',
                    },
                },
                equipmentModel: {
                    name: 'Рабочее место',
                    type: 'string',
                    sizeVariant: 'long',
                    typeProps: {
                        defaultValue: 'Не указана',
                    },
                    sourceObject: 'data',
                },
                inventoryNumber: {
                    name: 'Инвентарный номер',
                    type: 'string',
                    sizeVariant: 'medium',
                    typeProps: {
                        defaultValue: 'Не указан',
                    },
                    sourceObject: 'data',
                },
            },
            dateInfoFields: [
                'createdAtUtc',
                'changedAtUtc',
            ],
            mainInfoFields: [
                'type',
                'statusCode',
                'priority',
                'equipmentModel',
                {
                    title: 'Цех',
                    fieldName: 'department',
                    propertyName: 'manufacture',
                },
                'inventoryNumber',
                {
                    title: 'Участок',
                    fieldName: 'department',
                    propertyName: 'sector',
                },
            ],
            userInfoFields: [
                'assignee',
                'author',
            ],
            measurementList: measurementList,
            attachmentGridProps: {
                printBtn: 'Распечатать накладную',
                deleteData: 'Удалить накладную',
                widgetTitle: 'Накладная',
                uploadFileBtn: 'Загрузить накладную',
                uploadOtherFile: 'Загрузить другую накладную',
                downloadTemplate: 'Сформировать шаблон накладной',
                downloadTemplateBtn: 'Сформировать шаблон накладной',
            },
            attachmentGridProps2: {
                printBtn: 'Распечатать ведомость',
                deleteData: 'Удалить ведомость',
                widgetTitle: 'Ведомость',
                uploadFileBtn: 'Загрузить ведомость',
                uploadOtherFile: 'Загрузить другую ведомость',
                downloadTemplate: 'Сформировать шаблон ведомости',
                downloadTemplateBtn: 'Сформировать шаблон ведомости',
            },
            attachmentGridColumns: [
                {
                    width: 340,
                    headerName: 'Код',
                    sourceProperty: 'code',
                },
                {
                    flex: 1,
                    minWidth: 150,
                    headerName: 'Название',
                    sourceProperty: 'name',
                },
                {
                    type: 'number',
                    width: 90,
                    headerName: 'Количество',
                    sourceProperty: 'amount',
                },
                {
                    type: 'number',
                    width: 90,
                    headerName: '% износа',
                    sourceProperty: 'wearPercentage',
                },
            ],
        },
    },
    {
        documentCode: 'UGM',
        name: 'Управление оборудованием',
        settings: {
            sla: [
                {
                    code: 'latencyPeriod',
                    name: 'Время до взятия заявки в работу',
                    calcFn: 'secondDiff',
                    unitType: 'min',
                    normative: 15,
                    baseObject: 'firstStatusHistory',
                    baseStatus: 'new',
                    updateMode: 'keepFirstValue',
                    triggerStatuses: [
                        'work',
                    ],
                },
                {
                    code: 'responseTime',
                    name: 'Время на решение заявки',
                    calcFn: 'secondDiff',
                    unitType: 'min',
                    normative: 240,
                    baseObject: 'lastStatusHistory',
                    baseStatus: 'work',
                    updateMode: 'sumValue',
                    triggerStatuses: [
                        'completed',
                    ],
                },
                {
                    code: 'totalTime',
                    name: 'Общее время до завершения заявки',
                    calcFn: 'secondDiff',
                    unitType: 'hour',
                    normative: 8,
                    baseObject: 'firstStatusHistory',
                    baseStatus: 'new',
                    updateMode: 'replaceLastValue',
                    triggerStatuses: [
                        'all',
                    ],
                },
                {
                    code: 'reopenCount',
                    name: 'Количество возвратов',
                    calcFn: 'intVal',
                    unitType: 'times',
                    normative: 0,
                    baseObject: 'statusCounter',
                    baseStatus: 'new',
                    updateMode: 'replaceLastValue',
                    triggerStatuses: [
                        'new',
                    ],
                },
            ],
            plugins: [
                'attachments',
                'comments',
                'timeTracking',
            ],
            typeList: [
                {
                    code: 'scheduled',
                    icon: {
                        name: 'CalendarMonth',
                        color: '#5472d3',
                    },
                    name: 'Плановый ремонт',
                },
                {
                    code: 'unscheduled',
                    icon: {
                        name: 'EventBusy',
                        color: '#6d4c41',
                    },
                    name: 'Внеплановый ремонт',
                },
            ],
            workflow: [
                {
                    toStatus: 'work',
                    fromStatus: 'new',
                    toolbarAction: {
                        button: 'В работу',
                        formProps: {
                            title: 'В работу',
                            addons: [
                                'comment',
                            ],
                            button: 'В работу',
                            fields: [
                                'assignee',
                            ],
                        },
                    },
                },
                {
                    toStatus: 'completed',
                    fromStatus: 'work',
                    toolbarAction: {
                        button: 'Завершить задачу',
                        formProps: {
                            title: 'Завершить задачу',
                            addons: [
                                'comment',
                            ],
                            button: 'Завершить',
                            fields: [],
                        },
                    },
                },
                {
                    toStatus: 'new',
                    fromStatus: 'completed',
                    toolbarAction: {
                        button: 'Переоткрыть',
                        formProps: {
                            title: 'Переотрытие задания',
                            addons: [
                                'comment',
                            ],
                            button: 'Переоткрыть',
                            fields: [
                                'assignee',
                            ],
                        },
                    },
                },
            ],
            editFields: [
                'type',
                {
                    type: 'hr',
                },
                'title',
                'description',
                'priority',
                'assignee',
                'department',
                'departmentIds',
            ],
            statusList: [
                {
                    code: 'new',
                    name: 'Новая',
                    styleCode: 'blue',
                },
                {
                    code: 'work',
                    name: 'В работе',
                    styleCode: 'yellow',
                },
                {
                    code: 'completed',
                    name: 'Завершенная',
                    styleCode: 'green',
                },
            ],
            cloneFields: [
                'title',
            ],
            gridColumns: [
                {
                    width: 30,
                    headerName: '',
                    sourceProperty: 'priority',
                },
                {
                    headerName: '',
                    sourceProperty: 'type',
                },
                {
                    width: 150,
                    headerName: 'Ключ',
                    componentName: 'TwoLineCell',
                    sourcePropertyMap: {
                        primaryValue: 'issueKey',
                        secondaryValue: 'statusCode',
                    },
                },
                'title',
                {
                    width: 200,
                    headerName: 'Автор/Обновлено',
                    componentName: 'TwoLineCell',
                    sourcePropertyMap: {
                        primaryValue: 'author',
                        secondaryValue: 'changedAtUtc',
                    },
                },
            ],
            createFields: [
                'type',
                {
                    type: 'hr',
                },
                'title',
                'description',
                'priority',
                'assignee',
                'department',
                'departmentIds',
            ],
            dataProperties: {
                type: {
                    name: 'Тип',
                    type: 'identifier',
                    sizeVariant: 'medium',
                    editProps: {
                        allowEditOnDetailsPage: true,
                    },
                    typeProps: {
                        initValue: 'scheduled',
                        sourceListPropertyKey: 'typeList',
                    },
                    columnProps: {
                        align: 'center',
                        width: 30,
                    },
                    sourceObject: 'data',
                },
                title: {
                    name: 'Название',
                    type: 'string',
                    sizeVariant: 'long',
                    isRequired: true,
                    columnProps: {
                        flex: 1,
                        width: 100,
                        minWidth: 100,
                    },
                },
                amount: {
                    name: 'Количество',
                    type: 'number',
                    sizeVariant: 'short',
                    sourceObject: 'data',
                },
                author: {
                    name: 'Автор',
                    type: 'user',
                    sizeVariant: 'medium',
                    columnProps: {
                        width: 100,
                    },
                    isDerivative: true,
                    derivativeProps: {
                        sourcePropertyPath: 'createdBy',
                    },
                },
                assignee: {
                    name: 'Исполнитель',
                    type: 'user',
                    sizeVariant: 'medium',
                    columnProps: {
                        width: 100,
                    },
                    isDerivative: true,
                    derivativeProps: {
                        sourcePropertyPath: 'assigneeId',
                    },
                },
                issueKey: {
                    name: 'Ключ',
                    type: 'documentKey',
                    sizeVariant: 'short',
                    columnProps: {
                        width: 90,
                    },
                },
                priority: {
                    name: 'Приоритет',
                    type: 'priority',
                    sizeVariant: 'medium',
                    editProps: {
                        allowEditOnDetailsPage: true,
                    },
                    typeProps: {
                        initValue: '2',
                    },
                    columnProps: {
                        align: 'center',
                        width: 85,
                    },
                },
                department: {
                    name: 'Цех.Участок',
                    type: 'entity',
                    sizeVariant: 'short',
                    typeProps: {
                        entityType: 'department',
                    },
                    sourceObject: 'data',
                },
                statusCode: {
                    name: 'Статус',
                    type: 'status',
                    sizeVariant: 'medium',
                    columnProps: {
                        width: 95,
                    },
                },
                description: {
                    name: 'Описание',
                    type: 'text',
                    sizeVariant: 'full',
                },
                changedAtUtc: {
                    name: 'Обновлено',
                    type: 'utcDate',
                    typeProps: {
                        displayFormat: 'dd.MM.yyyy HH:mm',
                    },
                    columnProps: {
                        width: 135,
                    },
                },
                createdAtUtc: {
                    name: 'Дата создания',
                    type: 'utcDate',
                    typeProps: {
                        displayFormat: 'dd.MM.yyyy HH:mm',
                    },
                    columnProps: {
                        width: 135,
                    },
                },
                departmentIds: {
                    name: 'Список участков',
                    type: 'array',
                    editProps: {
                        isHidden: true,
                    },
                    typeProps: {
                        entityType: 'number',
                    },
                },
                equipmentModel: {
                    name: 'Рабочее место',
                    type: 'string',
                    sizeVariant: 'long',
                    typeProps: {
                        defaultValue: 'Не указана',
                    },
                    sourceObject: 'data',
                },
                inventoryNumber: {
                    name: 'Инвентарный номер',
                    type: 'string',
                    sizeVariant: 'medium',
                    typeProps: {
                        defaultValue: 'Не указан',
                    },
                    sourceObject: 'data',
                },
            },
            dateInfoFields: [
                'createdAtUtc',
                'changedAtUtc',
            ],
            mainInfoFields: [
                'type',
                'statusCode',
                'priority',
                'equipmentModel',
                {
                    title: 'Цех',
                    fieldName: 'department',
                    propertyName: 'manufacture',
                },
                'inventoryNumber',
                {
                    title: 'Участок',
                    fieldName: 'department',
                    propertyName: 'sector',
                },
            ],
            userInfoFields: [
                'assignee',
                'author',
            ],
            measurementList: measurementList,
        },
    },
    {
        documentCode: 'WIP',
        name: 'НЗП и готовые материалы',
        settings: {
            sla: [
                {
                    code: 'latencyPeriod',
                    name: 'Время до взятия заявки в работу',
                    calcFn: 'secondDiff',
                    unitType: 'min',
                    normative: 15,
                    baseObject: 'firstStatusHistory',
                    baseStatus: 'new',
                    updateMode: 'keepFirstValue',
                    triggerStatuses: [
                        'work',
                    ],
                },
                {
                    code: 'responseTime',
                    name: 'Время на решение заявки',
                    calcFn: 'secondDiff',
                    unitType: 'min',
                    normative: 240,
                    baseObject: 'lastStatusHistory',
                    baseStatus: 'work',
                    updateMode: 'sumValue',
                    triggerStatuses: [
                        'completed',
                    ],
                },
                {
                    code: 'totalTime',
                    name: 'Общее время до завершения заявки',
                    calcFn: 'secondDiff',
                    unitType: 'hour',
                    normative: 8,
                    baseObject: 'firstStatusHistory',
                    baseStatus: 'new',
                    updateMode: 'replaceLastValue',
                    triggerStatuses: [
                        'all',
                    ],
                },
                {
                    code: 'reopenCount',
                    name: 'Количество возвратов',
                    calcFn: 'intVal',
                    unitType: 'times',
                    normative: 0,
                    baseObject: 'statusCounter',
                    baseStatus: 'new',
                    updateMode: 'replaceLastValue',
                    triggerStatuses: [
                        'new',
                    ],
                },
            ],
            plugins: [
                'attachments',
                'comments',
                'attachmentWithTemplate',
                'timeTracking',
            ],
            testData: [
                {
                    id: 1,
                    amount: '7 шт',
                    operation: 'Зачистка',
                    routeCode: '2088',
                    operationCode: '0005',
                    mesOrderNumber: 'MES-32',
                    productUnitCode: '#102240001',
                    productUnitName: 'Полуфабрикат О2',
                    routePointNumber: 'Точка маршрута: 4',
                },
                {
                    id: 2,
                    amount: '2 шт',
                    operation: 'Вальцовочная',
                    routeCode: '2088',
                    operationCode: '0020',
                    mesOrderNumber: 'MES-46',
                    productUnitCode: '#102240001',
                    productUnitName: 'Полуфабрикат О2',
                    routePointNumber: 'Точка маршрута: 4',
                },
                {
                    id: 3,
                    amount: '104 шт',
                    operation: 'Зачистка',
                    routeCode: '2090',
                    operationCode: '0005',
                    mesOrderNumber: 'MES-54',
                    productUnitCode: '#102240002',
                    productUnitName: 'Полуфабрикат О1',
                    routePointNumber: 'Точка маршрута: 4',
                },
                {
                    id: 4,
                    amount: '3 шт',
                    operation: 'Дробеструйная',
                    routeCode: '2090',
                    operationCode: '0025',
                    mesOrderNumber: 'MES-6',
                    productUnitCode: '#102240002',
                    productUnitName: 'Полуфабрикат О1',
                    routePointNumber: 'Точка маршрута: 4',
                },
                {
                    id: 5,
                    amount: '7 шт',
                    operation: 'Зачистка',
                    routeCode: '2095',
                    operationCode: '0005',
                    mesOrderNumber: 'MES-15',
                    productUnitCode: '#102240005',
                    productUnitName: 'Полуфабрикат Д5',
                    routePointNumber: 'Точка маршрута: 2',
                },
                {
                    id: 6,
                    amount: '102 шт',
                    operation: 'Токарнокарусельная',
                    routeCode: '2095',
                    operationCode: '0010',
                    mesOrderNumber: 'MES-22',
                    productUnitCode: '#102240005',
                    productUnitName: 'Полуфабрикат Д5',
                    routePointNumber: 'Точка маршрута: 2',
                },
                {
                    id: 7,
                    amount: '57 шт',
                    operation: 'Зачистка',
                    routeCode: '2095',
                    operationCode: '0005',
                    mesOrderNumber: 'MES-15',
                    productUnitCode: '#102240005',
                    productUnitName: 'Полуфабрикат Д5',
                    routePointNumber: 'Точка маршрута: 3',
                },
                {
                    id: 8,
                    amount: '6 шт',
                    operation: 'Зачистка',
                    routeCode: '2084',
                    operationCode: '0005',
                    mesOrderNumber: 'MES-56',
                    productUnitCode: '#10224100101',
                    productUnitName: 'Полуфабрикат Д1',
                    routePointNumber: 'Точка маршрута: 1',
                },
                {
                    id: 9,
                    amount: '1 шт',
                    operation: 'Зачистка',
                    routeCode: '2084',
                    operationCode: '0005',
                    mesOrderNumber: 'MES-8',
                    productUnitCode: '#10224100101',
                    productUnitName: 'Полуфабрикат Д1',
                    routePointNumber: 'Точка маршрута: 1',
                },
                {
                    id: 10,
                    amount: '2 шт',
                    operation: 'Зачистка',
                    routeCode: '542',
                    operationCode: '0005',
                    mesOrderNumber: 'MES-16',
                    productUnitCode: '#11200101',
                    productUnitName: 'Полуфабрикат П1',
                    routePointNumber: 'Точка маршрута: 1',
                },
                {
                    id: 11,
                    amount: '14 шт',
                    operation: 'Зачистка',
                    routeCode: '542',
                    operationCode: '0005',
                    mesOrderNumber: 'MES-26',
                    productUnitCode: '#11200101',
                    productUnitName: 'Полуфабрикат П1',
                    routePointNumber: 'Точка маршрута: 1',
                },
                {
                    id: 12,
                    amount: '54 шт',
                    operation: 'Зачистка',
                    routeCode: '542',
                    operationCode: '0005',
                    mesOrderNumber: 'MES-26',
                    productUnitCode: '#11200101',
                    productUnitName: 'Полуфабрикат П1',
                    routePointNumber: 'Точка маршрута: 3',
                },
                {
                    id: 13,
                    amount: '2 шт',
                    operation: 'Зачистка',
                    routeCode: '543',
                    operationCode: '0005',
                    mesOrderNumber: 'MES-23',
                    productUnitCode: '#112007',
                    productUnitName: 'Полуфабрикат С1',
                    routePointNumber: 'Точка маршрута: 1',
                },
                {
                    id: 14,
                    amount: '14 шт',
                    operation: 'Зачистка',
                    routeCode: '543',
                    operationCode: '0005',
                    mesOrderNumber: 'MES-25',
                    productUnitCode: '#112007',
                    productUnitName: 'Полуфабрикат С1',
                    routePointNumber: 'Точка маршрута: 1',
                },
                {
                    id: 15,
                    amount: '54 шт',
                    operation: 'Зачистка',
                    routeCode: '543',
                    operationCode: '0005',
                    mesOrderNumber: 'MES-25',
                    productUnitCode: '#112007',
                    productUnitName: 'Полуфабрикат С1',
                    routePointNumber: 'Точка маршрута: 3',
                },
            ],
            typeList: [
                {
                    code: 'change-wip',
                    icon: {
                        name: 'Category',
                        color: '#5472d3',
                    },
                    name: 'Изменение НЗП',
                },
                {
                    code: 'product-release',
                    icon: {
                        name: 'Workspaces',
                        color: '#6d4c41',
                    },
                    name: 'Списание готовых материалов',
                },
            ],
            workflow: [
                {
                    toStatus: 'work',
                    fromStatus: 'new',
                    toolbarAction: {
                        button: 'В работу',
                        formProps: {
                            title: 'В работу',
                            addons: [
                                'comment',
                            ],
                            button: 'В работу',
                            fields: [
                                'assignee',
                            ],
                        },
                    },
                },
                {
                    toStatus: 'completed',
                    fromStatus: 'work',
                    toolbarAction: {
                        button: 'Завершить задачу',
                        formProps: {
                            title: 'Завершить задачу',
                            addons: [
                                'comment',
                            ],
                            button: 'Завершить',
                            fields: [],
                        },
                    },
                },
                {
                    toStatus: 'new',
                    fromStatus: 'completed',
                    toolbarAction: {
                        button: 'Переоткрыть',
                        formProps: {
                            title: 'Переотрытие задания',
                            addons: [
                                'comment',
                            ],
                            button: 'Переоткрыть',
                            fields: [
                                'assignee',
                            ],
                        },
                    },
                },
            ],
            editFields: [
                'type',
                {
                    type: 'hr',
                },
                'title',
                'description',
                'priority',
                'assignee',
                'department',
                'departmentIds',
            ],
            statusList: [
                {
                    code: 'new',
                    name: 'Новая',
                    styleCode: 'blue',
                },
                {
                    code: 'work',
                    name: 'В работе',
                    styleCode: 'yellow',
                },
                {
                    code: 'completed',
                    name: 'Завершенная',
                    styleCode: 'green',
                },
            ],
            cloneFields: [
                'title',
            ],
            gridColumns: [
                {
                    width: 30,
                    headerName: '',
                    sourceProperty: 'priority',
                },
                {
                    headerName: '',
                    sourceProperty: 'type',
                },
                {
                    width: 150,
                    headerName: 'Ключ',
                    componentName: 'TwoLineCell',
                    sourcePropertyMap: {
                        primaryValue: 'issueKey',
                        secondaryValue: 'statusCode',
                    },
                },
                'title',
                {
                    width: 200,
                    headerName: 'Автор/Обновлено',
                    componentName: 'TwoLineCell',
                    sourcePropertyMap: {
                        primaryValue: 'author',
                        secondaryValue: 'changedAtUtc',
                    },
                },
            ],
            createFields: [
                'type',
                {
                    type: 'hr',
                },
                'title',
                'description',
                'priority',
                'assignee',
                'department',
                'departmentIds',
            ],
            dataProperties: {
                type: {
                    name: 'Тип',
                    type: 'identifier',
                    sizeVariant: 'medium',
                    editProps: {
                        allowEditOnDetailsPage: true,
                    },
                    typeProps: {
                        initValue: 'scheduled',
                        sourceListPropertyKey: 'typeList',
                    },
                    columnProps: {
                        align: 'center',
                        width: 30,
                    },
                    sourceObject: 'data',
                },
                title: {
                    name: 'Название',
                    type: 'string',
                    sizeVariant: 'long',
                    isRequired: true,
                    columnProps: {
                        flex: 1,
                        width: 100,
                        minWidth: 100,
                    },
                },
                author: {
                    name: 'Автор',
                    type: 'user',
                    sizeVariant: 'medium',
                    columnProps: {
                        width: 100,
                    },
                    isDerivative: true,
                    derivativeProps: {
                        sourcePropertyPath: 'createdBy',
                    },
                },
                assignee: {
                    name: 'Исполнитель',
                    type: 'user',
                    sizeVariant: 'medium',
                    columnProps: {
                        width: 100,
                    },
                    isDerivative: true,
                    derivativeProps: {
                        sourcePropertyPath: 'assigneeId',
                    },
                },
                issueKey: {
                    name: 'Ключ',
                    type: 'documentKey',
                    sizeVariant: 'short',
                    columnProps: {
                        width: 90,
                    },
                },
                priority: {
                    name: 'Приоритет',
                    type: 'priority',
                    sizeVariant: 'medium',
                    editProps: {
                        allowEditOnDetailsPage: true,
                    },
                    typeProps: {
                        initValue: '2',
                    },
                    columnProps: {
                        align: 'center',
                        width: 85,
                    },
                },
                department: {
                    name: 'Цех.Участок',
                    type: 'entity',
                    sizeVariant: 'short',
                    typeProps: {
                        entityType: 'department',
                    },
                    sourceObject: 'data',
                },
                statusCode: {
                    name: 'Статус',
                    type: 'status',
                    sizeVariant: 'medium',
                    columnProps: {
                        width: 95,
                    },
                },
                description: {
                    name: 'Описание',
                    type: 'text',
                    sizeVariant: 'full',
                },
                changedAtUtc: {
                    name: 'Обновлено',
                    type: 'utcDate',
                    typeProps: {
                        displayFormat: 'dd.MM.yyyy HH:mm',
                    },
                    columnProps: {
                        width: 135,
                    },
                },
                createdAtUtc: {
                    name: 'Дата создания',
                    type: 'utcDate',
                    typeProps: {
                        displayFormat: 'dd.MM.yyyy HH:mm',
                    },
                    columnProps: {
                        width: 135,
                    },
                },
                departmentIds: {
                    name: 'Список участков',
                    type: 'array',
                    editProps: {
                        isHidden: true,
                    },
                    typeProps: {
                        entityType: 'number',
                    },
                },
            },
            dateInfoFields: [
                'createdAtUtc',
                'changedAtUtc',
            ],
            mainInfoFields: [
                'type',
                'statusCode',
                {
                    title: 'Цех',
                    fieldName: 'department',
                    propertyName: 'manufacture',
                },
                'priority',
                {
                    title: 'Участок',
                    fieldName: 'department',
                    propertyName: 'sector',
                },
            ],
            userInfoFields: [
                'assignee',
                'author',
            ],
            measurementList: measurementList,
            attachmentGridProps: {
                printBtn: 'Распечатать накладную',
                deleteData: 'Удалить накладную',
                widgetTitle: 'Накладная',
                uploadFileBtn: 'Загрузить накладную',
                uploadOtherFile: 'Загрузить другую накладную',
                downloadTemplate: 'Сформировать шаблон накладной',
                downloadTemplateBtn: 'Сформировать шаблон накладной',
            },
            attachmentGridProps2: {
                printBtn: 'Распечатать ведомость',
                deleteData: 'Удалить ведомость',
                widgetTitle: 'Ведомость',
                uploadFileBtn: 'Загрузить ведомость',
                uploadOtherFile: 'Загрузить другую ведомость',
                downloadTemplate: 'Сформировать шаблон ведомости',
                downloadTemplateBtn: 'Сформировать шаблон ведомости',
            },
            attachmentGridColumns: [
                {
                    width: 100,
                    headerName: 'MES-заказ',
                    filterTypes: [
                        'change-wip',
                        'product-release',
                    ],
                    componentName: 'documentKey',
                    sourceProperty: 'mesOrderNumber',
                },
                {
                    flex: 1,
                    headerName: 'Материал',
                    componentName: 'TwoLineCell',
                    componentProps: {
                        secondaryValueTooltip: 'Артикул материала',
                    },
                    sourcePropertyMap: {
                        primaryValue: 'productUnitName',
                        secondaryValue: 'productUnitCode',
                    },
                },
                {
                    width: 150,
                    headerName: 'ВИМ',
                    filterTypes: [
                        'change-wip',
                    ],
                    componentName: 'TwoLineCell',
                    sourcePropertyMap: {
                        primaryValue: 'routeCode',
                        secondaryValue: 'routePointNumber',
                    },
                },
                {
                    width: 200,
                    headerName: 'Операция',
                    filterTypes: [
                        'change-wip',
                    ],
                    componentName: 'TwoLineCell',
                    componentProps: {
                        secondaryValueTooltip: 'Номер операции',
                    },
                    sourcePropertyMap: {
                        primaryValue: 'operation',
                        secondaryValue: 'operationCode',
                    },
                },
                {
                    type: 'number',
                    width: 100,
                    headerName: 'Количество',
                    filterTypes: [
                        'change-wip',
                        'product-release',
                    ],
                    sourceProperty: 'amount',
                },
            ],
        },
    },
];